import { login, logout, getInfo } from '@/api/user'
import { getMenu } from "@/api/system";
import { getToken, setToken, removeToken } from '@/utils/auth'
import router, { resetRouter } from '@/router'
import md5 from 'js-md5'
import Layout from '@/layout'

const state = {
  token: getToken(),
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  userInfo: '',
  rightRouters: [],
  isAddRouters: false,
  routerComponents: []
}

const mutations = {
  SET_TOKEN: (state, token) => {
    state.token = token
  },
  SET_INTRODUCTION: (state, introduction) => {
    state.introduction = introduction
  },
  SET_NAME: (state, name) => {
    state.name = name
  },
  SET_AVATAR: (state, avatar) => {
    state.avatar = avatar
  },
  SET_ROLES: (state, roles) => {
    state.roles = roles
  },
  SET_USERINFO: (state, userInfo) => {
    state.userInfo = userInfo
  },
  SET_RIGHTROUTERS: (state, rightRouters) => {
    state.rightRouters = rightRouters
  },
  SET_ISADDROUTERS: (state) => {
    state.isAddRouters = true
  },
  SET_ROUTERCOMPONENTS: (state, routerComponents) => {
    state.routerComponents = routerComponents
  },
}

const actions = {
  // user login
  login({ commit }, userInfo) {
    const { username, password, appCode, isExternal, isActive } = userInfo
    return new Promise((resolve, reject) => {
      login({ username: username.trim(), password: md5(password), appCode: appCode, isExternal, isActive }).then(response => {
        if(response && response.success == true){
          const { data } = response
          localStorage.setItem('userInfo', JSON.stringify(data))
          commit('SET_TOKEN', data.username)
          commit('SET_ROLES', data.roleIds)
          commit('SET_NAME', data.userNameCn)
          commit('SET_AVATAR', 'https://wpimg.wallstcn.com/f778738c-e4f8-4870-b634-56703b4acafe.gif')
          commit('SET_INTRODUCTION', data.officeName)
          commit('SET_USERINFO', data)
          setToken(data.username)
        }

        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // get user info
  getInfo({ commit, state }) {
    return new Promise((resolve, reject) => {
      getInfo(state.token).then(response => {
        const { data } = response

        if (!data) {
          reject('Verification failed, please Login again.')
        }

        const { roles, name, avatar, introduction } = data

        // roles must be a non-empty array
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!')
        }

        commit('SET_ROLES', roles)
        commit('SET_NAME', name)
        commit('SET_AVATAR', avatar)
        commit('SET_INTRODUCTION', introduction)
        resolve(data)
      }).catch(error => {
        reject(error)
      })
    })
  },

  // user logout
  logout({ commit, state, dispatch }) {
    return new Promise((resolve, reject) => {
      logout(state.token).then(() => {
        commit('SET_TOKEN', '')
        commit('SET_ROLES', [])
        removeToken()
        resetRouter()

        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, { root: true })


        resolve()
      }).catch(error => {
        reject(error)
      })
    })
  },

  // remove token
  resetToken({ commit }) {
    return new Promise(resolve => {
      commit('SET_TOKEN', '')
      commit('SET_ROLES', [])
      removeToken()
      resolve()
    })
  },

  // dynamically modify permissions
  async changeRoles({ commit, dispatch }, role) {
    const token = role + '-token'

    commit('SET_TOKEN', token)
    setToken(token)

    const { roles } = await dispatch('getInfo')

    resetRouter()

    // generate accessible routes map based on roles
    const accessRoutes = await dispatch('permission/generateRoutes', roles, { root: true })
    // dynamically add accessible routes
    router.addRoutes(accessRoutes)

    // reset visited views and cached views
    dispatch('tagsView/delAllViews', null, { root: true })
  },

  async getMenu({ commit }) {
    return new Promise((resolve, reject) => {
    let obj={
      appCode: "CTS_WEB"
    }
    getMenu(obj).then(res => {
      if(res.success) {
        let result = JSON.parse(res.resourceList)
        result = result.filter(item => item.menuType === 'vue');
        console.log(result)
        let system = result.filter(item => item.urlType === 'SYSTEM');
        system.forEach(parentItem => {
          let children = [];
          parentItem.c = children
          result.forEach(item => {
            if(parentItem.sysResourceId === item.sysResourceId) return
            if(parentItem.sysResourceId === item.parentResourceId) {
              item.parent = parentItem.url
              children.push(item)
            }
          })
        })
        commit('SET_RIGHTROUTERS', system);
        const flattenSystem = flatten(system);
        router.addRoutes(flattenSystem)
        commit('SET_ISADDROUTERS');
        commit('SET_ROUTERCOMPONENTS', flattenSystem);
        resolve(flattenSystem)
      } else {
        reject(res.message)
      }
    }).catch(err => {
      reject(err)
    })
  })
  }
}
function flatten(data,parentItem) {
  data.forEach(item => {
    if(item.urlType === 'SYSTEM' && !(item.parentResourceId)) {
        item.path = '/'+item.url.toLowerCase()
        item.component = Layout
        item.name = item.url.toLowerCase()
        item.children = []
        item.meta = { title: item.urlTitle ,icon: item.urlImg }
    } else if(item.urlType === 'MENU') {
        item.path = item.url;
      if(item.urlParamList == null || item.urlParamList.length ==0){
          item.component = require(`../../views${item.url}.vue`).default
        }else if( item.tableName &&  item.tableName.length >0) {
          item.component = require(`../../views${item.tableName}.vue`).default;
        }
        item.name = item.urlImg
        item.hidden = item.urlParamList == 1
        item.meta = { title: item.urlTitle  }
        parentItem.children.push(item)
    }

    if(item.c && item.c.length> 0) flatten(item.c,item)
  })
  return data
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}
